/* SQ B&A Card — "ler mais" inline expand/collapse
   Document-level delegation so it works inside any section
   that renders the sq-ba-card snippet. */
(function () {
  document.addEventListener('click', function (e) {
    var link = e.target.closest('.baa-read-more');
    if (!link) return;
    e.preventDefault();
    var quote = link.closest('.baa-quote');
    if (!quote) return;
    var full = quote.getAttribute('data-full-quote');
    if (!full) return;

    var closeQuote = '<span class="baa-quote-close">\u201D</span>';
    var isExpanded = quote.hasAttribute('data-expanded');
    if (isExpanded) {
      var truncated = quote.getAttribute('data-truncated');
      quote.innerHTML = truncated + closeQuote + ' <a href="javascript:void(0)" class="baa-read-more">ler mais</a>';
      quote.removeAttribute('data-expanded');
    } else {
      if (!quote.hasAttribute('data-truncated')) {
        var clone = quote.cloneNode(true);
        var linkEl = clone.querySelector('.baa-read-more');
        if (linkEl) linkEl.remove();
        var closeEl = clone.querySelector('.baa-quote-close');
        if (closeEl) closeEl.remove();
        quote.setAttribute('data-truncated', clone.innerHTML.trim());
      }
      quote.innerHTML = full + closeQuote + ' <a href="javascript:void(0)" class="baa-read-more">ler menos</a>';
      quote.setAttribute('data-expanded', '');
    }
  });
})();
